<template>
  <base-stripe-table
    :headers="headers"
    :fetch-action="'listTaxRates'"
    :items-getter="'getTaxRates'"
    :pagination-getter="'getTaxRatePagination'"
  >
    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
        >
          <td>{{ item.display_name }}</td>
          <td>{{ item.jurisdiction }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.percentage }}% <span class="caption grey--text">{{ item.inclusive ? 'incl.' : '' }}</span></td>
          <td>
            <v-chip
              v-if="!isArchived(item)"
              color="success"
              small
              outlined
            >
              Active
            </v-chip>
            <v-chip
              v-if="isArchived(item)"
              color="grey"
              small
              outlined
            >
              Archived
            </v-chip>
          </td>
          <td v-date="item.created" />
          <td class="text-right">
            <v-progress-circular
              v-if="isLoadingMap[item.id] === true"
              :size="20"
              :width="2"
              color="primary"
              left
              indeterminate
            />
            <v-menu
              v-if="isLoadingMap[item.id] !== true"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <tax-rate-update-dialog
                  v-if="!isArchived(item)"
                  :id="item.id"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      @click.stop=""
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon
                            left
                            small
                          >
                            edit
                          </v-icon>
                          Edit
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </tax-rate-update-dialog>


                <v-list-item
                  v-if="!isArchived(item)"
                  @click="onArchive(item.id)"
                >
                  <v-list-item-content>
                    <v-list-item-title class="red--text">
                      <v-icon
                        left
                        small
                        color="error"
                      >
                        archive
                      </v-icon>
                      Archive
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="isArchived(item)"
                  @click="onUnarchive(item.id)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left>
                        unarchive
                      </v-icon>
                      Unarchive
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </tbody>
    </template>
  </base-stripe-table>
</template>
<script>
import { mapActions } from 'vuex'
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import TaxRateUpdateDialog from "./TaxRateUpdateDialog"

export default {
  components: {
    TaxRateUpdateDialog,
    BaseStripeTable
  },
  methods: {
    ...mapActions([ 'updateTaxRate' ]),
    isArchived(item) {
      return item.active === false
    },
    async onArchive(id){
      const active = false
      const payload = { id, active }

      this.setIsLoadingMap(id, true)
      await this.updateTaxRate(payload)
      this.setIsLoadingMap(id, false)
    },
    async onUnarchive(id){
      const active = true
      const payload = { id, active }

      this.setIsLoadingMap(id, true)
      await this.updateTaxRate(payload)
      this.setIsLoadingMap(id, false)
    },
    setIsLoadingMap(id, value) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [id]: !!value
      }
    }
  },
  data() {
    return {
      isLoadingMap: {},
      headers: [
        {
          text: 'Type',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Region',
          sortable: false,
        },
        {
          text: 'Description',
          sortable: false
        },
        {
          text: 'Rate',
          aligh: 'left',
          sortable: false
        },
        {
          text: 'Status',
          sortable: false
        },
        {
          text: 'Created',
          sortable: false
        },
        {
          text: '',
          sortable: false
        },
      ]
    }
  }
}
</script>
